import Timestamp from "components/Timestamp";
import Box from "ds/components/Box";
import Link from "ds/components/Link";
import Tile from "ds/components/Tile";
import TileTitle from "ds/components/Tile/Title";
import Typography from "ds/components/Typography";
import { Revision } from "types/generated";
import { getRepoRevisionUrl } from "utils/spaceliftRepo";

import { SHORT_SHA_LENGTH } from "../../constants";

type SpaceliftVcsRepoCommitsItemProps = {
  revision: Revision;
  repoId: string;
};

const SpaceliftVcsRepoCommitsItem = ({ revision, repoId }: SpaceliftVcsRepoCommitsItemProps) => {
  const shortSha = revision.sha.slice(0, SHORT_SHA_LENGTH);
  const commitUrl = getRepoRevisionUrl(repoId, revision.sha);

  return (
    <Tile
      title={
        <Link variant="secondary" href={commitUrl}>
          <TileTitle>
            <span>({shortSha})</span> {revision.message}
          </TileTitle>
        </Link>
      }
    >
      {revision.description && (
        <Typography variant="p-body3" tag="p" color="secondary">
          {revision.description}
        </Typography>
      )}

      <Box>
        <Typography color="secondary" variant="p-body3" tag="p">
          {revision.authorEmail || revision.authorName}&nbsp;-&nbsp;
        </Typography>

        <Timestamp timestamp={revision.createdAt} color="secondary" />
      </Box>
    </Tile>
  );
};

export default SpaceliftVcsRepoCommitsItem;
